import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { addServiceData, updateServiceData, deleteServiceData } from '../../../../../actions/services-api';
import ServiceData from '../../../../../constants/models/serviceData';
import Generic from '../../../../../constants/models/servicePayloads/generic';
import { convertConnectionTypesToServiceType } from '../../../../../constants/utils/connectionTypes';
import * as R from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import * as Loadings from '../../../../../constants/loadings/service';

export const BranchBox = ({ branch, connectionType, index, removeBranch, bottomRef, formRef }) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const services = useSelector(state => state.services);
    const [payloads, setPayloads] = useState({ items: [{ id: '', payload: new Generic({ reference: '', comment: '' }) }] });
    const [toDelete, setToDelete] = useState([]);
    const [autoFocus, setAutoFocus] = useState(false);
    const [tmpBranch, setTmpBranch] = useState(branch);

    function loadReferences() {
        let allServicesWithSameBranch = !R.isNil(services) && !R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType]) ? services.serviceData[connectionType].filter(b => b.serviceId === branch.serviceId || (R.isNil(branch.serviceId) && branch.id === b.serviceId)) : [];
        let tmpPayloads = { items: tmpBranch === branch ? payloads.items.filter(i => toDelete.findIndex(d => d === i.id) === -1) : [{ id: '', payload: new Generic({ reference: '', comment: '' }) }] };
        if (tmpBranch !== branch){
            setTmpBranch(branch);
        }
        allServicesWithSameBranch.forEach(br => {
            if (tmpPayloads.items.findIndex(tmp => tmp.id === br.id) === -1) {
                tmpPayloads.items.push({ id: br.id, payload: br.payload });
            }
        });
        if (allServicesWithSameBranch.length > 0 && tmpPayloads.items.length > 0) {
            if (tmpPayloads.items[0].payload.reference === '') {
                tmpPayloads.items.splice(0, 1);
            }
            setPayloads(tmpPayloads);
        }
        setToDelete([]);
    }

    useEffect(() => {
        loadReferences();
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        loadReferences();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branch, connectionType, !R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType]) && services.serviceData[connectionType], !R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType]) && services.serviceData[connectionType].length]);
    
    return (
        <div>
            {
                payloads.items.map((br, payIndex) => {
                    return (
                        <div className="form-row">
                            <div className="col form-group mb-xs">
                                <div className="flex-row gx-2 align-items-center mb-1">
                                    <label className="h6 font-weight-bolder my-auto" htmlFor={"reference" + payIndex + '-' + index} >Référence</label>
                                    <p className="form-text small text-gray my-auto ml-auto" data-toggle="tooltip" data-placement="top" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="Une référence permet à vos organismes de vous identifier afin de faire les démarches nécessaires."><i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i></p>
                                </div>
                                <input required={true} autoFocus={(autoFocus && payIndex === payloads.items.length - 1)} type="text" className="form-control rounded" id={"reference" + payIndex + '-' + index} placeholder="xxxxxxxxxxx" aria-describedby="basic-addon2" value={!R.isNil(br) && !R.isNil(br.payload) ? br.payload.reference : ''} onChange={(e) => {
                                    e.preventDefault();
                                    let tmpPayload = JSON.parse(JSON.stringify(payloads.items));

                                    let payloadIndex = tmpPayload.findIndex((p, idx) => idx === payIndex);
                                    if (payloadIndex !== -1) {
                                        tmpPayload[payloadIndex] = { id: br.id, payload: new Generic({ reference: e.target.value, comment: tmpPayload[payloadIndex].payload.comment }) };
                                    }
                                    else {
                                        tmpPayload.push({ id: '', payload: new Generic({ reference: e.target.value, comment: '' }) });
                                    }
                                    setPayloads({ ...payloads, items: tmpPayload });
                                }} />
                            </div>
                            <div className="col form-group mb-xs">
                                <div className="flex-row gx-2 align-items-center mb-1">
                                    <label htmlFor={"referenceComentaire" + payIndex + '-' + index} className="label h6 lh-root font-weight-bold">Commentaire</label>
                                    <p className="form-text small text-gray my-auto ml-auto" data-toggle="tooltip" data-placement="top" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="Les cases commentaires sont personnelles (ne seront pas visibles par le mandataire), elles vous permettent d'ajouter des notes à vos services."><i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i></p>
                                </div>
                                <div className="input-group mb-0">
                                    <input type="text" className="form-control rounded" id={"referenceComentaire" + payIndex + '-' + index} placeholder="xxxxxxxxxxx" value={!R.isNil(br) && !R.isNil(br.payload) ? br.payload.comment : ''} onChange={(e) => {
                                        e.preventDefault();
                                        let tmpPayload = JSON.parse(JSON.stringify(payloads.items));

                                        let payloadIndex = tmpPayload.findIndex((p, idx) => idx === payIndex);
                                        if (payloadIndex !== -1) {
                                            tmpPayload[payloadIndex] = { id: br.id, payload: new Generic({ reference: tmpPayload[payloadIndex].payload.reference, comment: e.target.value }) };
                                        }
                                        else {
                                            tmpPayload.push({ id: '', payload: new Generic({ reference: '', comment: e.target.value }) });
                                        }
                                        setPayloads({ ...payloads, items: tmpPayload });
                                    }} />
                                    {(payIndex === 0 ? br.payload.reference !== '' : true) ?
                                        <span className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none rounded" id="basic-addon2" onClick={(e) => {
                                            e.preventDefault();
                                            if (!R.isNil(br.id) && br.id !== '') {
                                                let tmpToDelete = toDelete.concat(br.id);
                                                setToDelete(tmpToDelete);
                                                dispatch(deleteServiceData(br.id, connectionType));
                                            }
                                            let newPayload = payloads.items.filter((p, idx) => idx !== payIndex);
                                            if (newPayload.length === 0) {
                                                newPayload.push({ id: '', payload: new Generic({ reference: '', comment: '' }) });
                                            }
                                            setPayloads({ ...payloads, items: newPayload });
                                        }}><i className="eva eva-trash-2-outline"></i></span>

                                        : ''}
                                </div>
                            </div>
                            <div className={"col invalid-feedback alert-danger alert"}>Champs invalide</div>
                        </div>
                    )
                })
            }
            {
                <button type="button" className="btn btn-icon p-0 align-middle text-gray no-outline mr-auto mb-xs"
                    onClick={
                        (e) => {
                            e.preventDefault();
                            setPayloads({ ...payloads, items: payloads.items.concat({ id: '', payload: new Generic({ reference: '', comment: '' }) }) });
                            setAutoFocus(true);
                        }
                    }
                >
                    <i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary mr-1"></i>
                    <span className="btn-text aling-middle">Ajouter une autre référence</span>
                </button>
            }

            <div className="form-footer mb-xl-0 mt-2 mb-6" ref={bottomRef}>
                <button className={"btn btn-sm btn-alert-info border-none loading-btn"+(services.isLoading.includes(Loadings.ADD_NEW_SERVICE+branch.id) || services.isLoading.includes(Loadings.UPDATING_SERVICE_DATA+branch.id) ? ' show': '')} 
                disabled={services.isLoading.includes(Loadings.ADD_NEW_SERVICE+branch.id) || services.isLoading.includes(Loadings.UPDATING_SERVICE_DATA+branch.id)}
                onClick={(e) => {
                    e.preventDefault();
                    formRef.current.classList.add('was-validated');
                    if (formRef.current.checkValidity() || (payloads.items.length === 1 && payloads.items[0].payload.reference !== '')) {
                        payloads.items.length > 0 && payloads.items.forEach(payload => {
                            let serviceData = new ServiceData({ userId: user.user.id, serviceType: convertConnectionTypesToServiceType(connectionType), serviceId: !R.isNil(branch.serviceId) && !R.isNil(branch.id) ? branch.id : branch.serviceId, payload: payload.payload });
                            if (R.isNil(serviceData.serviceId) || serviceData.serviceId === ''){
                                serviceData.serviceId = branch.id;
                            }
                            if (R.isNil(payload.id) || payload.id === '') {
                                dispatch(addServiceData(serviceData));
                            }
                            else {
                                serviceData.id = branch.id;
                                dispatch(updateServiceData(serviceData));
                            }
                        });
                        setPayloads({ payloads, items: payloads.items.filter(i => i.id !== '') });
                        setToDelete([]);
                    }
                }}>
                    enregistrer
                                <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                </button>


                <span className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none" id="basic-addon2" onClick={(e) => {
                    e.preventDefault();
                    if ((R.isNil(branch) || R.isNil(branch.serviceId)) && !R.isNil(removeBranch)) {
                            removeBranch(branch.serviceId);
                    }
                    else {
                        let allServicesToDelete = services.serviceData[connectionType].filter(s => s.serviceId === branch.serviceId);
                        allServicesToDelete.forEach(s => {
                            dispatch(deleteServiceData(s.id, connectionType));
                        });
                    }
                }}><i className="eva eva-trash-outline"></i></span>
            </div>
        </div>
    )
}